export const columnsDataDevelopment = [
  {
    Header: "NAME",
    accessor: "name",
  },
  {
    Header: "TECH",
    accessor: "tech",
  },
  {
    Header: "DATE",
    accessor: "date",
  },
  {
    Header: "PROGRESS",
    accessor: "progress",
  },
];

export const columnsDataCheck = [
  {
    Header: "STUDENT",
    accessor: "submittedBy.name",
  },
  {
    Header: "TEAM NUMBER",
    accessor: "team.name",
  },
  {
    Header: "SUBMITTED DATE",
    accessor: "createdDate",
  },
  {
    Header: "STATUS",
    accessor: "feedback.status",
  },
  {
    Header: "POINTS",
    accessor: "feedback.points",
  },
  {
    Header: "DETAILS",
    // accessor: "details",
  },

];

export const columnsChallenges = [
  {
    Header: "STUDENT",
    accessor: "submittedBy.name",
  },
  {
    Header: "SUBMITTED DATE",
    accessor: "createdDate",
  },
  {
    Header: "STATUS",
    accessor: "feedback.status",
  },
  {
    Header: "POINTS",
    accessor: "feedback.points",
  },
  {
    Header: "DETAILS",
    // accessor: "details",
  },
];

export const columnsFeedback = [
  {
    Header: "STUDENT",
    accessor: "submittedBy.name",
  },
  {
    Header: "SUBMITTED DATE",
    accessor: "createdDate",
  },
  {
    Header: "STATUS",
    accessor: "feedback.status",
  },
  {
    Header: "POINTS",
    accessor: "feedback.points",
  },
  {
    Header: "DETAILS",
    // accessor: "details",
  },
];




export const columnsDataColumns = [
  {
    Header: "DUE DATE",
    accessor: "createdDate",
  },
  {
    Header: "STATUS",
    accessor: "feedback.status",
  },
  {
    Header: "POINTS",
    accessor: "feedback.points",
  },
  {
    Header: "DETAILS",
    // accessor: "details",
  },
];

export const columnsDataComplex = [
  {
    Header: "MODEL NAME",
    accessor: "modelName",
  },
  {
    Header: "BUILD PLATES",
    accessor: "buildPlates",
  },
  {
    Header: "PARTS WEIGHT",
    accessor: "partsWeight",
  },
  {
    Header: "RECOMMEND MATERIAL",
    accessor: "recommendMaterial",
  },
  {
    Header: "AVERAGE PRINT DURATION",
    accessor: "averagePrint",
  },
  {
    Header: "PARTS QUANTITY",
    accessor: "partsQuantity",
  },
  {
    Header: "SELECT",
    accessor: "select",
  },
];
export const modelAdded = [
  {
    Header: "MODEL NAME",
    accessor: "modelName",
  },
  {
    Header: "BUILD PLATES",
    accessor: "buildPlates",
  },
  {
    Header: "PARTS WEIGHT",
    accessor: "partsWeight",
  },
  {
    Header: "RECOMMEND MATERIAL",
    accessor: "recommendMaterial",
  },
  {
    Header: "AVERAGE PRINT DURATION",
    accessor: "averagePrint",
  },
  {
    Header: "PARTS QUANTITY",
    accessor: "partsQuantity",
  },
];
export const modelEdit = [
  {
    Header: "MODEL NAME",
    accessor: "modelName",
  },
  {
    Header: "BUILD PLATES",
    accessor: "buildPlates",
  },
  {
    Header: "PARTS WEIGHT",
    accessor: "partsWeight",
  },
  {
    Header: "RECOMMEND MATERIAL",
    accessor: "recommendMaterial",
  },
  {
    Header: "AVERAGE PRINT DURATION",
    accessor: "averagePrint",
  },
  {
    Header: "PARTS QUANTITY",
    accessor: "partsQuantity",
  },
  {
    Header: "ACTION",
    // accessor: "select",
  },
];


